export default function makeLinkStatic(link: string) {
  if (link.startsWith('http') || link.startsWith('https')) {
    return link;
  }
  return `https://www.surveymonkey.com${link}`;
}
